import { Dialog } from "primereact/dialog";
import { useScaleRequirementsEditHistory } from "../hooks/queries";
import { ProgressSpinner } from "primereact/progressspinner";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { useState } from "react";
import { Tag } from "primereact/tag";

export default function ScaleHistoryDialog({
  clientId,
  medicalCenterId,
  visible,
  onHide,
}) {
  const scaleHistory = useScaleRequirementsEditHistory({
    clientId,
    medicalCenterId,
  });

  const [selectedForView, setSelectedForView] = useState(null);

  return (
    <Dialog
      visible={visible}
      onHide={() => {
        onHide();
        setSelectedForView(null);
      }}
      draggable={false}
      header="Historial de cambios"
      className="w-7"
      headerClassName="pb-2"
    >
      {selectedForView === null ? (
        <div className="grid mt-1">
          {scaleHistory.isLoading && <ProgressSpinner className="col-12" />}
          {!medicalCenterId && (
            <span className="col-12">
              <i className="pi pi-exclamation-circle"></i> Seleccione un
              proveedor.
            </span>
          )}
          {scaleHistory.data?.length === 0 && (
            <span className="col-12">No se hallaron resultados.</span>
          )}
          {scaleHistory.data?.map((item) => (
            <>
              <div className="col-3">
                <span>{item.edited_at}</span>
              </div>

              <div className="col-6 flex flex-column gap-2">
                <span>{item.edited_by.full_name}</span>
                <span style={{ overflowWrap: "break-word" }}>
                  {item.edited_by.username}
                </span>
                <span>{item.edited_by.phone_number}</span>
                {item.observation && (
                  <span>
                    <b>Observación: </b>
                    {item.observation}
                  </span>
                )}
              </div>

              <div className="col-3">
                {item.can_edit_scale_change === null ? (
                  <Button
                    label="Ver cambios"
                    icon="pi pi-eye"
                    onClick={() => setSelectedForView(item)}
                  />
                ) : (
                  <div className="flex flex-column gap-2 align-items-center">
                    <span>¿Clínica puede editar? </span>
                    <Tag
                      value={item.can_edit_scale_change ? "SI" : "NO"}
                      severity={item.can_edit_scale_change ? "success" : "danger"}
                      className="px-3"
                    />
                  </div>
                )}
              </div>
              <Divider className="col-12 my-0" />
            </>
          ))}
        </div>
      ) : (
        <div className="flex flex-column">
          <section>
            <h4>Requerimientos modificados:</h4>
            <ul className="mb-0">
              {Object.entries(selectedForView.medical_center_requirements).map(
                ([requirement, state]) => (
                  <li key={requirement}>
                    <span>
                      <b>{requirement}</b>: {state}
                    </span>
                  </li>
                )
              )}
            </ul>
          </section>
          <section>
            <h4>Precios:</h4>
            <ul className="mb-0">
              {Object.entries(selectedForView.prices).map(
                ([requirement, price]) => (
                  <li key={requirement}>
                    {price[0] === null ? (
                      <span>
                        <b>{requirement}</b>: {price[1]} REF
                      </span>
                    ) : (
                      <span>
                        <b>{requirement}</b>: De {price[0]} REF a {price[1]} REF
                      </span>
                    )}
                  </li>
                )
              )}
            </ul>
          </section>
          <Button
            label="Volver"
            text
            link
            severity="secondary"
            className="mt-2"
            onClick={() => setSelectedForView(null)}
          />
        </div>
      )}
    </Dialog>
  );
}
